import classNames from "classnames/bind";
import styles from "./Filter.module.css";
import { Button, Input, Select } from "antd";
import { DownIcons, SearchBlack } from "../../../../components/Icons/Icons";
import { useEffect, useState } from "react";
import Modal from "../ModalConnectTelegram/Modal";
import { manageNotification } from "../../../../services/api/manageNotification";
const cx = classNames.bind(styles);

function Filter({ handleRefresh, onChange, form }) {
    const [isShowModalAdd, setIsShowModalAdd] = useState(false);
    const [listMethod, setListMethod] = useState([]);
    const handleShowModalAdd = () => {
        setIsShowModalAdd(!isShowModalAdd)
    }
    useEffect(() => {
        const getListMethod = async () => {
            try {
                const res = await manageNotification.getListNotificationMethod();
                if (res) {
                    const methods = res?.map(item => {
                        return {
                            label: item?.DETAIL,
                            value: item?.METHOD
                        }
                    })
                    setListMethod(methods);
                }
            } catch (error) {
                // console.log(error);

            }
        }
        getListMethod()
    }, [])
    return (
        <div className={cx("filter")}>
            <div className={cx("form-filter")}>
                <label>
                    <p className={cx('label')}>Tên tài khoản</p>
                    <Input
                        className={cx('search')}
                        prefix={<SearchBlack />}
                        placeholder="Tìm kiếm..."
                        onChange={(e) => onChange("name", e?.target?.value)}
                    />
                </label>
                <label>
                    <p className={cx('label')}>Kênh thông báo</p>
                    <Select
                        className={cx("select")}
                        placeholder="Tất cả"
                        suffixIcon={<DownIcons />}
                        options={[{
                            label: "Tất cả",
                            value: null
                        }].concat(listMethod)}
                        onChange={(val) => onChange("method", val)}
                    />
                </label>
            </div>
            <Button
                type="primary"
                className={cx("btnAdd")}
                onClick={handleShowModalAdd}
            >
                Thêm mới
            </Button>
            {isShowModalAdd && <Modal onClose={handleShowModalAdd} handleRefresh={handleRefresh} />}
        </div>
    )
}

export default Filter;